import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/packages/theme-chalk/lib/index.css'
import moment from 'moment'
import 'moment/locale/zh-cn'
import request from '@/utils/request'
import _ from 'lodash'
import './directive/index'
window.moment = moment

Vue.use(ElementUI)

Vue.prototype.moment = moment
Vue.prototype._ = _

Vue.config.productionTip = false

async function run () {
  const res = await request.get('/auth/getInfo')
  store.commit('setUserInfo', res.data)
}

let loadingInstance = ElementUI.Loading.service({
  text: '加载中...'
})

run().then(() => {
  setTimeout(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    loadingInstance.close()
  }, 1000)
})
